<template>
  <div class="index-1-left-1">
    <div class="card-header">
      <div class="header-accent"></div>
      <div class="header-content">
        <div class="header-icon">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="header-title">
          <span>{{ $t('propertyIndex.communityInfo') }}</span>
          <div class="header-subtitle">{{ $t('propertyIndex.communityDesc') || '社区核心数据总览' }}</div>
        </div>
      </div>
    </div>
    <div style="height: 300px;">
      <div class="stats-grid">
        <div v-for="(item, index) in stats" :key="index" class="stat-card" :class="'stat-' + (index + 1)" @click="_toPage(item.path)">
          <div class="stat-icon">
            <i :class="item.icon"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ indexCommunityViewInfo[item.key] }}</div>
            <div class="stat-label">{{ $t(`propertyIndex.${item.label}`) }}</div>
          </div>
          <div class="stat-trend">
            <i class="el-icon-data-line"></i>
          </div>
        </div>
      </div>
      <div class="quick-actions">
        <div class="action-card" @click="_toOwner">
          <div class="action-icon resident">
            <i class="el-icon-user"></i>
          </div>
          <div class="action-info">
            <div class="action-title">{{ $t('propertyIndex.residentReg') }}</div>
            <div class="action-count">
              <span class="count-number">{{ indexCommunityViewInfo.ownerCount }}</span>
              <span class="count-unit">{{ $t('propertyIndex.unit') }}</span>
            </div>
            <div class="action-desc">{{ $t('propertyIndex.registerResident') }}</div>
          </div>
          <div class="action-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="action-card" @click="_toCar">
          <div class="action-icon vehicle">
            <i class="el-icon-truck"></i>
          </div>
          <div class="action-info">
            <div class="action-title">{{ $t('propertyIndex.vehicle') }}</div>
            <div class="action-count">
              <span class="count-number">{{ indexCommunityViewInfo.carCount }}</span>
              <span class="count-unit">{{ $t('propertyIndex.unit') }}</span>
            </div>
            <div class="action-desc">{{ $t('propertyIndex.viewVehicle') }}</div>
          </div>
          <div class="action-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

    </div>
    
  </div>
</template>

<script>
import { getPropertyAssetsIndex } from '@/api/index/propertyIndexApi'

export default {
  name: 'IndexCommunity',
  data() {
    return {
      indexCommunityViewInfo: {
        floorCount: 0,
        roomCount: 0,
        shopCount: 0,
        ownerCount: 0,
        spaceCount: 0,
        carCount: 0,
      },
      stats: [
        { key: 'floorCount', label: 'building', icon: 'el-icon-office-building', path: '/pages/property/room' },
        { key: 'roomCount', label: 'house', icon: 'el-icon-house', path: '/pages/property/room' },
        // { key: 'shopCount', label: 'shop', icon: 'el-icon-shopping-bag-2' },
        { key: 'spaceCount', label: 'parkingSpace', icon: 'el-icon-truck', path: '/pages/property/listParkingSpace' }
      ]
    }
  },
  created() {
  },
  methods: {
    _loadPropertyIndexAssets() {
      const param = {
        page: 1,
        row: 10,
        communityId: this.getCommunityId()
      }

      getPropertyAssetsIndex(param)
        .then(res => {
          if (res.code === 0) {
            Object.assign(this.indexCommunityViewInfo, res.data)
          }
        })
        .catch(err => {
          console.error('请求失败处理', err)
        })
    },
    _toOwner() {
      this.$router.push('/pages/property/listOwner?tab=ownerInfo')
    },
    _toCar() {
      this.$router.push('/pages/property/listOwnerCar?tab=ownerCar')
    },
    _toPage(path) {
      if (path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index-1-left-1 {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  overflow: hidden;
  transition: box-shadow 0.3s;
  height: 100% !important;  
    
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
  
  .card-header {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 0 10px;
    
    .header-accent {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: linear-gradient(180deg, #409EFF, #1890ff);
      border-radius: 2px;
    }
    
    .header-content {
      display: flex;
      align-items: center;
      margin-left: 10px;
      
      .header-icon {
        width: 48px;
        height: 48px;
        background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
        
        i {
          font-size: 24px;
          color: #fff;
        }
      }
      
      .header-title {
        span {
          font-size: 18px;
          font-weight: bold;
          color: #303133;
          display: block;
        }
        
        .header-subtitle {
          font-size: 12px;
          color: #909399;
          margin-top: 4px;
        }
      }
    }
  }
  
  .index-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: left;
    color: #333;
  }
  
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    
    .stat-card {
      display: flex;
      align-items: center;
      padding: 15px;
      background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
      border-radius: 12px;
      border: 1px solid #f0f0f0;
      transition: all 0.3s;
      position: relative;
      overflow: hidden;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
      }
      
      &.stat-1::before { background: linear-gradient(90deg, #409EFF, #67C23A); }
      &.stat-2::before { background: linear-gradient(90deg, #67C23A, #E6A23C); }
      &.stat-3::before { background: linear-gradient(90deg, #E6A23C, #F56C6C); }
      &.stat-4::before { background: linear-gradient(90deg, #F56C6C, #909399); }
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }
      
      .stat-icon {
        width: 48px;
        height: 48px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        flex-shrink: 0;
        
        .stat-1 & { background: linear-gradient(135deg, #ecf5ff, #d9ecff); i { color: #409EFF; } }
        .stat-2 & { background: linear-gradient(135deg, #f0f9eb, #e1f3d8); i { color: #67C23A; } }
        .stat-3 & { background: linear-gradient(135deg, #fdf6ec, #faecd8); i { color: #E6A23C; } }
        .stat-4 & { background: linear-gradient(135deg, #f4f4f5, #e9e9eb); i { color: #909399; } }
        
        i {
          font-size: 22px;
        }
      }
      
      .stat-content {
        flex: 1;
        min-width: 0;
        
        .stat-number {
          font-size: 22px;
          font-weight: bold;
          color: #303133;
          line-height: 1.2;
        }
        
        .stat-label {
          font-size: 12px;
          color: #909399;
          margin-top: 4px;
        }
      }
      
      .stat-trend {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 14px;
        color: #c0c4cc;
        opacity: 0;
        transition: opacity 0.3s;
      }
      
      &:hover .stat-trend {
        opacity: 1;
      }
    }
  }
  
  .quick-actions {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    padding-top: 20px;
    
    .action-card {
      display: flex;
      align-items: center;
      padding: 15px 18px;
      background: #fafafa;
      border-radius: 12px;
      border: 1px solid #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background: linear-gradient(135deg, #ecf5ff, #fff);
        border-color: #409EFF;
        transform: translateX(4px);
        
        .action-arrow {
          opacity: 1;
          transform: translateX(0);
        }
        
        .action-icon {
          transform: scale(1.1);
        }
      }
      
      .action-icon {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 14px;
        flex-shrink: 0;
        transition: transform 0.3s;
        
        &.resident {
          background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
          i { color: #fff; font-size: 20px; }
        }
        
        &.vehicle {
          background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%);
          i { color: #fff; font-size: 20px; }
        }
      }
      
      .action-info {
        flex: 1;
        min-width: 0;
        
        .action-title {
          font-size: 14px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 4px;
        }
        
        .action-count {
          .count-number {
            font-size: 20px;
            font-weight: bold;
            color: #303133;
          }
          .count-unit {
            font-size: 12px;
            color: #909399;
            margin-left: 2px;
          }
        }
        
        .action-desc {
          font-size: 12px;
          color: #c0c4cc;
          margin-top: 2px;
        }
      }
      
      .action-arrow {
        opacity: 0.5;
        transform: translateX(-8px);
        transition: all 0.3s;
        
        i {
          font-size: 16px;
          color: #909399;
        }
      }
    }
  }
  
  .index-1-left-img {
    width: 40px;
    height: 40px;
    background: #f0f7ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    
    i {
      font-size: 20px;
      color: #409EFF;
    }
  }
  
  .margin-top-sm {
    margin-top: 5px;
  }
}
</style>